import { detect } from 'detect-browser';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { ProfileRootType } from '../../@types/auth';
import { getProfile } from '../../api/auth';
import { useCommonContext } from '../provider/CommonProvider';
import ChannelService from './MyChannerTalk';

export const channelService = new ChannelService();

const ChannelTalkButton: React.FC = () => {
  const [userProfile, setUserProfile] = useState<ProfileRootType | null>(null);
  const { hasAccessToken } = useCommonContext();

  useEffect(() => {
    if (hasAccessToken) {
      getProfile().then((res) => {
        setUserProfile(res.data);
      });
    }
  }, []);

  // 채널톡 초기화 및 부트 옵션 설정
  const bootChannelTalk = (pluginKey: string) => {
    const userOS = detect()?.os;
    const isAndroid = userOS?.toLowerCase().includes('android');
    const isIOS = userOS?.toLowerCase().includes('ios');

    const options = {
      pluginKey, // 채널톡 플러그인 키
      memberId: userProfile ? userProfile.memberId : '',
      profile: { mobileNumber: userProfile ? userProfile.mobileNo : '' },
      hideChannelButtonOnBoot: false, // 부트 시 기본 버튼 숨김 설정 (false로 설정하여 버튼 표시)
      hidePopup: isMobile && (isAndroid || isIOS), // 모바일에서 팝업 숨김 설정
      zIndex: 20,
    };

    // 채널톡 메신저 커스텀 디자인 변경
    const setStyles = (element: HTMLElement, styles: { [key: string]: string }) => {
      if (!element) return;
      Object.assign(element.style, styles);
    };

    const channelTalkElementHandler = () => {
      const channelTalkParent = document.querySelector('#ch-plugin-entry')?.children[0]?.shadowRoot?.children[0]
        ?.children[1] as HTMLElement;
      const channelTalkButtonWrapper = channelTalkParent?.querySelector('button') as HTMLElement;
      const channelTalkButtonInner = channelTalkButtonWrapper?.children[0] as HTMLElement;
      const channelTalkButtons = channelTalkButtonInner?.children;
      const channelTalkButton = channelTalkButtonInner?.children[3] as HTMLElement;
      const channelTalkMinimizeButton = channelTalkButtonInner?.children[4] as HTMLElement;

      const hasAllElements =
        channelTalkParent &&
        channelTalkButtonWrapper &&
        channelTalkButtonInner &&
        channelTalkButtons &&
        channelTalkButton &&
        channelTalkMinimizeButton;
      if (!hasAllElements) return;

      setStyles(channelTalkParent, {
        bottom: isMobile ? '22px' : '53px',
        right: isMobile ? '22px' : '57px',
      });

      setStyles(channelTalkButtonInner, {
        backdropFilter: 'none',
        border: 'none',
        borderRadius: '50%',
      });

      setStyles(channelTalkMinimizeButton, {
        boxSizing: 'border-box',
        borderRadius: '50%',
        backgroundColor: '#191919',
        backdropFilter: 'none',
        boxShadow:
          'rgba(38, 38, 38, 1) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.1) 0px 4px 6px, rgba(0, 0, 0, 0.15) 0px 8px 30px',
      });

      const buttonIcon = channelTalkMinimizeButton?.children[0] as HTMLElement;
      if (buttonIcon) {
        setStyles(buttonIcon, {
          color: 'rgba(255, 255, 255, 1)',
        });
      }

      const imageCustomButtonViewElement = Array.from(channelTalkButtons).find((child) =>
        child.className.includes('ImageCustomButtonView'),
      )?.children[0] as HTMLElement;
      if (imageCustomButtonViewElement) {
        setStyles(imageCustomButtonViewElement, {
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          backgroundColor: '#191919',
          overflow: 'hidden',
          backdropFilter: 'none',
          boxShadow:
            'rgba(38, 38, 38, 1) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.1) 0px 4px 6px, rgba(0, 0, 0, 0.15) 0px 8px 30px',
        });
      }

      const senderButtonViewElement = Array.from(channelTalkButtons).find((child) =>
        child.className.includes('SenderButtonView'),
      ) as HTMLElement;
      if (senderButtonViewElement) {
        setStyles(senderButtonViewElement, {
          borderRadius: '50%',
          backdropFilter: 'none',
          overflow: 'hidden',
        });
      }

      const minimizeButtonViewElement = Array.from(channelTalkButtons).find((child) =>
        child.className.includes('MinimizeButtonView'),
      ) as HTMLElement;
      if (minimizeButtonViewElement) {
        setStyles(minimizeButtonViewElement, {
          boxSizing: 'border-box',
          borderRadius: '50%',
          backgroundColor: '#191919',
          boxShadow:
            'rgba(38, 38, 38, 1) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.1) 0px 4px 6px, rgba(0, 0, 0, 0.15) 0px 8px 30px',
        });
      }

      const iconButtonViewElement = Array.from(channelTalkButtonInner.children).find((child) =>
        child.className.includes('IconButtonView'),
      ) as HTMLElement;
      if (iconButtonViewElement) {
        setStyles(iconButtonViewElement, {
          borderRadius: '50%',
          backdropFilter: 'none',
          overflow: 'hidden',
        });
      }
    };

    channelService.boot(options, () => {
      setTimeout(() => {
        channelTalkElementHandler();
      }, 0);
    });

    channelService.onShowMessenger(channelTalkElementHandler);
    channelService.onHideMessenger(() => {
      setTimeout(() => {
        const channelTalkParent = document.querySelector('#ch-plugin-entry')?.children[0]?.shadowRoot?.children[0]
          ?.children[1] as HTMLElement;
        const channelTalkButtonWrapper = channelTalkParent?.querySelector('button') as HTMLElement;
        const channelTalkButtonInner = channelTalkButtonWrapper?.children[0] as HTMLElement;
        const channelTalkButtons = channelTalkButtonInner?.children;

        const hasAllElements = channelTalkButtonInner && channelTalkButtons;
        if (!hasAllElements) return;

        setStyles(channelTalkButtonInner, {
          backdropFilter: 'none',
          border: 'none',
          borderRadius: '50%',
        });

        const imageCustomButtonViewElement = Array.from(channelTalkButtons).find((child) =>
          child.className.includes('ImageCustomButtonView'),
        )?.children[0] as HTMLElement;
        if (imageCustomButtonViewElement) {
          setStyles(imageCustomButtonViewElement, {
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            backgroundColor: '#191919',
            backdropFilter: 'none',
            overflow: 'hidden',
            boxShadow:
              'rgba(38, 38, 38, 1) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.1) 0px 4px 6px, rgba(0, 0, 0, 0.15) 0px 8px 30px',
          });
        }

        const minimizeButtonViewElement = Array.from(channelTalkButtons).find((child) =>
          child.className.includes('MinimizeButtonView'),
        ) as HTMLElement;
        if (minimizeButtonViewElement) {
          setStyles(minimizeButtonViewElement, {
            boxSizing: 'border-box',
            borderRadius: '50%',
            backgroundColor: '#191919',
            backdropFilter: 'none',
            boxShadow:
              'rgba(38, 38, 38, 1) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.1) 0px 4px 6px, rgba(0, 0, 0, 0.15) 0px 8px 30px',
          });
        }

        const alertBadgestyledElement = Array.from(channelTalkButtons).find((child) =>
          child.className.includes('AlertBadgestyled'),
        ) as HTMLElement;
        if (alertBadgestyledElement) {
          setStyles(alertBadgestyledElement, {
            backdropFilter: 'none',
          });
        }
      }, 0);
    });
  };

  useEffect(() => {
    const pluginKey = process.env.REACT_APP_CHANNEL_TALK_KEY;
    if (!pluginKey) return;
    bootChannelTalk(pluginKey);

    return () => {
      channelService.shutdown(); // 컴포넌트 언마운트 시 채널톡 종료
    };
  }, [userProfile]);

  return null;
};

export default ChannelTalkButton;
